module.exports = __webpack_public_path__ + "img/Assistant.f59a9211.png";